import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import { userActions } from "../../_actions";
import { AdminMessage, Chart, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import EDUCalenderDark from "../../assets/images/EDUCalender-dark.png";
import EDUOptionDark from "../../assets/images/EDUOption-dark.png";
import EDUOption from "../../assets/images/EDUOption.png";
import ExamDark from "../../assets/images/Exam-dark.png";
import hospitals from "../../assets/images/hospitals.png";
import { NotifBadge } from "../../_components/notif-badge";

class IndexEduSupervisor_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wards: [],
      ward: "",
      general_indicators_info: null,
      chart1: null,
      chart2: null,
      indicator: "",
      isRequestEduDone: false,
      BtnList: [
        {
          img: hospitals,
          text: "بررسی نیازسنجی های سازمان",
          // to: null,
          to: "/pdp/supervisor/requestCheck",
          hover: "اعمال نظر به نیازسنجی های سازمان",
          onClick: () => "",
          notif: null,
        },
        {
          img: EDUOptionDark,
          text: "نیازسنجی های درخواستی کل بیمارستان",
          to: null,
          // to: "/pdp/requestEduStatus",
          hover: "ابتدا دوره های خود را درخواست کنید.",
          onClick: () => "",
          notif: null,
        },
        {
          img: EDUCalenderDark,
          text: "تقویم آموزشی",
          to: null,
          hover: "بزودی",
          onClick: () => "",
          notif: null,
        },
        {
          img: ExamDark,
          text: "آزمون های انلاین",
          to: null,
          hover: "بزودی",
          onClick: () => "",
          notif: null,
        },
        // {
        //   img: reportCardDark,
        //   text: "کارنامه آموزشی",
        //   to: null,
        //   hover: "بزودی",
        //   onClick: () => "",
        // },
      ],
      submitDate: "",
      statistics: [],
      validUser: false,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount() {
    const hasCode3015 = JSON.parse(localStorage.getItem("globalStorage"))
      .value.access.flatMap(({ access_code }) => access_code?.split("-") ?? [])
      .includes("3015");
    if (!hasCode3015) {
      userActions.failure("برای شما در این بخش دسترسی تعریف نشده است");
      this.props.history.push("/pdpSites");
    } else {
      this.getUserWards();
      // this.getCourses();
      this.getRequestedCourses();
    }
  }

  goBack = () => {
    this.props.history.goBack();
  };

  getStatistics = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/course/statistics`))
      .then((res) => {
        this.setState({ statistics: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getUserWards = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/user_wards`))
      .then((res) => {
        const superiorIds = res.data.map(({ user_id }) => +user_id);
        const myId = this.globalStorage.me.id;
        this.setState({ validUser: superiorIds.includes(myId) });
        this.getStatistics();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getCourses = () => {
    this.props
      .dispatch(userActions.API("get", `v1/user/hospital/courses`))
      .then((res) => {
        const randomCurrUserReq = res.data.find((req) => req.user_id);
        this.setState({
          submitDate: res.data[0] ? res.data[0].submitted_at : "",
          isRequestEduDone:
            randomCurrUserReq === undefined
              ? false
              : randomCurrUserReq.status !== "draft",
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getRequestedCourses = (job_group = null, post_name = null) => {
    // const { dispatch, getTitles } = this;

    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v1/user/hospital/supervisor/requested_courses?type=history${
            job_group ? `&job_group=${job_group}` : ""
          }${post_name ? `&post_name=${post_name}` : ""}`
        )
      )
      .then((res) => {
        // this.setState({ requested_courses: res.data });
        if (res.data.length !== 0) {
          const filterdData = res.data.filter(
            (person) =>
              person.requested_courses[0].status === "supervisor_pending" ||
              person.requested_courses[0].status === "rejected_by_superior"
          );
          const seenData = res.data.filter(
            (person) =>
              person.requested_courses[0].status !== "supervisor_pending" &&
              person.requested_courses[0].status !== "rejected_by_superior"
          );

          const notifNum = filterdData.length === 0 ? null : filterdData.length;

          this.setState({
            BtnList: this.state.BtnList.map((btn) => {
              if (btn.to === "/pdp/supervisor/requestCheck") {
                return {
                  img: hospitals,
                  text: "بررسی نیازسنجی های سازمان",
                  // to: null,
                  to: "/pdp/supervisor/requestCheck",
                  hover: "اعمال نظر به نیازسنجی های سازمان",
                  onClick: () => "",
                  notif: notifNum,
                };
              }
              if (seenData.length !== 0) {
                if (btn.text === "نیازسنجی های درخواستی کل بیمارستان") {
                  return {
                    img: EDUOption,
                    text: "نیازسنجی های درخواستی کل بیمارستان",
                    to: "/pdp/supervisor/requestEduStatus",
                    hover: "نیازسنجی های درخواستی کل بیمارستان",
                    onClick: () => "",
                    notif: null,
                  };
                }
              }
              return btn;
            }),
          });
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  warnAfterFinalSubmitReqEdu = (x = "0000/00/00") => {
    this.props.dispatch(
      userActions.warningWithSubmit(
        "متوجه شدم",
        `شما نیازسنجی آموزشی خود را در تاریخ ${x} نهایی کرده اید. جهت مشاهده وضعیت درخواست های خود به بخش بررسی وضعیت دوره های آموزشی مراجعه نمایید.`,
        "انصراف"
      )
    );
  };

  render() {
    const { indicator, ward, wards, BtnList, statistics } = this.state;
    const { indicators } = this.props.globalStorage;

    return (
      <div className="content bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp" />
        <div className="container-fluid">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <br />
        <div className="container-fluid">
          <div
            className="row my-1 d-flex flex-column justify-content-center align-items-center"
            style={{ gap: "50px" }}
          >
            <div className="col-lg-5 statistics mx-auto">
              <CardSection statistics={statistics} />
            </div>

            <div className="col-6 indexSec">
              <div className="border-0 h-100 ">
                <RoundedBtnWrapper>
                  {BtnList.map((btn) => (
                    <RoundedBtn
                      key={btn.text}
                      btn={btn}
                      onClick={btn.onClick}
                    />
                  ))}
                </RoundedBtnWrapper>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class CardSection extends Component {
  render() {
    if (this.props.statistics.length === 0) return null;
    const {
      total,
      total_accepted,
      total_rejected,
      total_requested_wards,
      total_required,
      total_supervisor_pending,
    } = this.props.statistics.supervisor;

    return (
      <>
        <div className="card-deck">
          <Card text="کل دوره های سازمان" value={total} bg="#0040ff" />
          <Card
            text="بخش های درخواست شده"
            value={total_requested_wards}
            bg="#18187a"
          />
          <Card
            text="دوره هـای تایید شده"
            value={total_accepted}
            bg="#1f3d80"
          />
        </div>
        <br />
        <div className="card-deck">
          <Card text="دوره هـای رد شده" value={total_rejected} bg="#00b088" />
          <Card
            text="دوره هـای الزامی سازمان"
            value={total_required}
            bg="#2bb5b2"
          />
          <Card
            text="دوره هایی که باید تایید کنید"
            value={total_supervisor_pending}
            bg="#52b9c7"
          />
        </div>
      </>
    );
  }
}

class Card extends Component {
  render() {
    const { text, value, bg } = this.props;
    return (
      <div
        className="card text-center"
        style={{ borderRadius: "20px", background: bg }}
      >
        <div className="card-body">
          <p className="card-title">
            <small
              className="iran-sans_Bold"
              style={{ color: "#ffffff", fontSize: "12px" }}
            >
              {text}
            </small>
          </p>
          <h5
            className="card-text iran-sans_Bold my-1"
            style={{ color: "#ffffff", fontSize: "20px" }}
          >
            {value}
          </h5>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0 shadow-smm m-0"
        style={{ borderRadius: "20px" }}
      >
        <div
          className="align-items-center card-body d-flex justify-content-center p-0"
          style={{ minHeight: "235px" }}
        >
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck" style={{ gap: "45px" }}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  renderContent = () => {
    const { img, text } = this.props.btn;
    return (
      <>
        <img
          src={img}
          alt=""
          width="75"
          height="75"
          className="rounded-circle"
        />
        <span
          className="iran-sans_Bold text-center text-dark my-2"
          style={{
            width: "100px",
            fontSize: "12px",
            paddingTop: "10px",
          }}
        >
          {text}
        </span>
      </>
    );
  };

  render() {
    const { renderContent } = this;
    const { onClick, btn } = this.props;
    const { to, hover } = btn;

    return (
      <div className="card text-center border-0 m-0">
        <div className="card-body border-0 d-flex justify-content-center p-0">
          {to ? (
            <NavLink
              className="d-flex flex-column align-items-center indexs btn p-0"
              to={to}
              data-tip={hover}
            >
              {renderContent()}
            </NavLink>
          ) : (
            <a
              className="d-flex flex-column align-items-center indexs btn p-0"
              data-tip={hover}
              onClick={onClick}
            >
              {renderContent()}
            </a>
          )}
          {/* <ReactTooltip type="dark" /> */}
        </div>
      </div>
    );
  }
}

const IndexEduSupervisor = connect((state) => ({
  globalStorage: state.globalStorage,
}))(IndexEduSupervisor_);
export { IndexEduSupervisor };
